import { useState } from 'react';

import type { ApiProduct } from '../../../../../models/ecommerce/product/ApiProduct';
import RecipeProductSubstituteTrigger from '../../../../cart/components/molecules/BuyableRecipeCartItem/RecipeProductSubstituteTrigger';
import RecipeProductListingItem from '../../../../cart/components/molecules/RecipeProductListingItem/RecipeProductListingItem';
import type { RecipeSection } from '../../../../recipe/hooks/useRecipeCart';
import type { RecipeItemState } from '../../../../recipe/models';
import { useCurrentPriceType } from '../../../hooks/useCurrentPriceType';
import DebouncedA11yAnnouncer from '../../A11yAnnouncer/DebouncedA11yAnnouncer';

const BuyableRecipeCartSectionItem = (props: {
    item: RecipeItemState;
    cartProducts: ApiProduct[];
    section: RecipeSection;
    className?: string;
    onQuantityChange: (item: RecipeItemState, newQuantity: number) => void;
    onItemRemove: (item: RecipeItemState) => void;
}) => {
    const connectedProduct = props.cartProducts.find(
        (product) => product.identifier === props.item.id,
    );
    const { currentPriceType } = useCurrentPriceType();

    const [quantity, setQuantity] = useState(props.item.quantity || 0);

    const handleQuantityChange = (newQuantity: number) => {
        props.onQuantityChange(props.item, newQuantity);
        setQuantity(newQuantity);
    };

    return (
        <>
            <DebouncedA11yAnnouncer
                text={`Ändrat till ${quantity} ${quantity === 1 ? 'vara' : 'varor'}`}
                announcerName="BuyableRecipeSectionItemAnnouncer"
            />
            <RecipeProductListingItem
                additionalClassNames={props.className}
                key={props.item.id}
                recipeItem={props.item}
                priceType={currentPriceType}
                product={connectedProduct}
                purchasable={props.item.purchasable}
                recipeSectionType="recipe"
                handleQuantityChange={handleQuantityChange}
                handleRemoveItem={() => props.onItemRemove(props.item)}
                withBuyButton={props.section.type === 'common'}
                substitutesTriggerSlot={
                    <RecipeProductSubstituteTrigger
                        item={{
                            stableId: props.item.substituteIdentifier,
                            productId: props.item.id,
                            quantity: props.item.quantity || 0,
                            name: connectedProduct?.name || props.item.name,
                            variantId: props.item.selectedVarianceCode,
                            recipeName: props.section.name,
                        }}
                    />
                }
            />
        </>
    );
};

export default BuyableRecipeCartSectionItem;
